const helpContentUrls = {
  '/html/welcome-help.html': './assets/html/welcome-help.html',
  '/html/femme-abo-brushing.html': './assets/html/femme-abo-brushing.html',
  '/html/femme-abo-coloration.html': './assets/html/femme-abo-coloration.html',
  '/html/femme-abo-gloss.html': './assets/html/femme-abo-gloss.html',
  '/html/femme-cheveux-courts.html': './assets/html/femme-cheveux-courts.html',
  '/html/femme-cheveux-extralongs.html': './assets/html/femme-cheveux-extralongs.html',
  '/html/femme-cheveux-longs.html': './assets/html/femme-cheveux-longs.html',
  '/html/femme-cheveux-milongs.html': './assets/html/femme-cheveux-milongs.html',
  '/html/femme-coloration-normal.html': './assets/html/femme-coloration-normal.html',
  '/html/femme-coloration-premium.html': './assets/html/femme-coloration-premium.html',
  '/html/femme-lissage-option.html': './assets/html/femme-lissage-option.html',
  '/html/homme-barbecourte.html': './assets/html/homme-barbecourte.html',
  '/html/homme-barbeprotocole.html': './assets/html/homme-barbeprotocole.html',
  '/html/homme-coupeclassique.html': './assets/html/homme-coupeclassique.html',
  '/html/homme-degrade.html': './assets/html/homme-degrade.html',
};

export const getHelpContentUrl = (path) => {
  return helpContentUrls[path] || path;
};

export const fetchHelpContent = async (path) => {
  const url = getHelpContentUrl(path);
  
  try {
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Erreur de chargement: ${response.status} ${response.statusText}`);
    }
    
    return await response.text();
  } catch (error) {
    console.error('Erreur lors du chargement du contenu d\'aide:', error);
    throw error;
  }
};

export const preloadHelpContents = () => {
  
  Object.values(helpContentUrls).forEach(url => {
    fetch(url)
      .then(response => {
        if (response.ok) {
          console.log(`Préchargement réussi: ${url}`);
        } else {
          console.warn(`Échec du préchargement: ${url}`);
        }
      })
      .catch(error => console.error(`Erreur de préchargement: ${url}`, error));
  });
};
